import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { translate } from '@jsverse/transloco';

import {
  ConfigurationRoute,
  ConfigurationRouteService,
} from 'app/providers/semantria-api/configuration-route.service';
import { ConfigurationService } from 'app/providers/semantria-api/configuration.service';
import { AlertService } from 'app/services/alert.service';
import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';
import { ConfigurationListEntry } from '../configuration-route-configurations/configuration-route-configurations.component';

@EnableClassTelemetry()
@Component({
  selector: 'app-edit-configurations-dialog',
  templateUrl: './edit-configurations-dialog.component.html',
  styleUrls: ['./edit-configurations-dialog.component.scss'],
  standalone: false,
})
export class EditConfigurationsDialogComponent implements OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  @Input() data;
  @Output() modalClosed: EventEmitter<any> = new EventEmitter<any>();
  includedConfigurations: ConfigurationListEntry[] = [];
  configurationRoute: ConfigurationRoute;

  isSaving: boolean;

  constructor(
    private configurationRouteService: ConfigurationRouteService,
    private configurationService: ConfigurationService,
    private alertService: AlertService
  ) {}

  ngOnInit(): void {
    this.configurationRoute = this.data.configurationRoute;
  }

  onIncludedConfigurationsChanged($event: ConfigurationListEntry[]) {
    this.includedConfigurations = $event;
  }

  cancel() {
    this.modalClosed.emit(null);
  }

  async save() {
    this.isSaving = true;

    const configurationRouteDto: ConfigurationRoute = JSON.parse(
      JSON.stringify(this.configurationRoute)
    );

    try {
      configurationRouteDto.configuration_map = this.includedConfigurations.reduce((prev, curr) => {
        if (curr.configurations.length) {
          prev[curr.languageId] = curr.configurations[0].configuration.id;
        }

        return prev;
      }, {});

      if (
        !this.includedConfigurations.some(
          (c) => c.languageId === configurationRouteDto.default_language_id
        )
      ) {
        configurationRouteDto.default_language_id = Object.keys(
          configurationRouteDto.configuration_map
        )[0];
      }

      if (
        !this.includedConfigurations.some(
          (c) => c.languageId === configurationRouteDto.translation_target_language_id
        )
      ) {
        configurationRouteDto.translation_target_language_id = null;
      }

      const res =
        await this.configurationRouteService.updateConfigurationRoute(configurationRouteDto);

      this.alertService.showToast(
        translate('configuration-routes.edit.edit-success', { route: configurationRouteDto.name })
      );
      this.configurationService.clearCache();

      this.modalClosed.emit(res);
    } catch (err) {
      this.alertService.showErrorToast(
        translate('configuration-routes.edit.edit-success', { route: configurationRouteDto.name }),
        err
      );
    } finally {
      this.isSaving = false;
    }
  }

  get isSaveEnabled() {
    return this.includedConfigurations.length > 0;
  }
}
